import { ICabergoline } from './Cabergoline.types';

export const initialCabergoline: ICabergoline = {
  dose: '',
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}